import{useContext as o}from"react";import{ROQContext as r}from"../contexts/roq-provider/roq-context.js";const t=()=>o(r);export{t as useRoqComponents};